import React from 'react'
import Sketch from 'react-p5'
import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

const extensions = require("./extensions")

let strings = new LocalizedStrings({
    en:{
        title:"blackwhite",
        description:""
    },
    de: {
        title:"schwarzweiss",
        description:""
    }
});

class PropertyChars {
    constructor(values) {
        this.value = extensions.randomChoice(values)
        this.pos = 0
        this.isProperty = true
    }

    next() {
        this.pos = (this.pos + 1) % this.value.length
        return this.value.substring(this.pos, this.pos+1)
    }

    getRandom() {
        let p = Math.random(1, this.value.length)
        return this.value.substring(p, p+1)
    }

    reset() {
        this.pos = 0
    }

}

class Property {
    constructor(startValue, growthFact, inc, mutationFact) {
        this.startValue = startValue
        this.value = startValue
        this.growthFact = growthFact
        this.inc = inc
        this.isProperty = true
    }

    get() {
        return this.value
    }

    reset() {
        this.value = this.startValue
    }

    advance() {
        this.value *= this.growthFact
        this.value += this.inc
    }
}

class ParameterSet {
    constructor(p5) {
        /*let fontSizeStart = p5.width/30
        let maxFontSize = p5.width/4
        this.stepSizeDiv = 4
        let fontSizeInc = (maxFontSize-fontSizeStart)/1000
        this.angleDevInc = 0.002*Math.PI/180

        this.angleDev = 10*Math.PI/180*/

        this.chars = new PropertyChars(["bdfhijklt", "b", "wmnuuuwuwuunm", "oöüu"])
        this.whiteChars = new PropertyChars(["!.-?", "#", "!!!!", ":-;,", "+**+()/&%$"])
        this.span = new Property(p5.random(1, 200), 1, 0, 0.2)
        this.letterCount = new Property(p5.random(1, 100), 1, 0, 0.2)
        this.fontSize = new Property(p5.random(p5.width/18, p5.width/12), 1, 0, 0.2)

        this.xspacing = this.fontSize.get() / 6
        this.yspacing = this.fontSize.get() / 4
        this.ythresh = p5.width/5*4
        this.strokeWidth = 0.8
    }

    step(p5) {
        var ySkip = 3
        var c

        if (this.initNewLine) {
            this.initNewLine = false
            this.x = 1

            this.lineAlpha = p5.random(0.05, 0.9)
            this.ypos = this.y*this.yspacing

            if (this.ypos > this.ythresh) {
                this.lineBreak = p5.random(p5.width / this.xspacing * 0.1, p5.width / this.xspacing*0.3)
            }
            else if (this.ypos > this.ythresh*0.6) {
                this.lineBreak = p5.random(p5.width / this.xspacing * 0.3, p5.width / this.xspacing)
            }
            else if (this.ypos > this.ythresh*0.5) {
                this.lineBreak = p5.random(p5.width / this.xspacing * 0.5, p5.width / this.xspacing)
            }
            else if (this.ypos > this.ythresh*0.4) {
                this.lineBreak = p5.random(p5.width / this.xspacing * 0.6, p5.width / this.xspacing)
            }
            else {
                this.lineBreak = p5.random(p5.width / this.xspacing * 0.9, p5.width / this.xspacing)
            }
        }

		var alpha = this.lineAlpha+p5.random(-0.1, 0.1)
		var notWhite = true

		if (this.ypos > this.ythresh*0.2) {
			if (this.x > this.lineBreak) {
				notWhite = false
			}
		}

		p5.textSize(p5.random(this.fontSize.get()*0.5, this.fontSize.get()*2))
		if (notWhite) {
			if (!this.drawWhite) {
				p5.stroke(0,0,0, 255)
				p5.fill(255, 255, 255, 255*alpha)

                c = this.chars.getRandom()
                p5.textAlign(p5.CENTER, p5.CENTER)
				p5.text(c, this.x*this.xspacing, this.ypos)
			}
			this.x++
        }
		else {
			if (this.drawWhite) {
                p5.stroke(255, 255, 255, 255)
				var gr = 0
				p5.fill(gr,gr,gr, alpha)

                c = this.whiteChars.getRandom()
                p5.textAlign(p5.CENTER, p5.CENTER)
				p5.text(c, this.x*this.xspacing, this.ypos)
			}
			this.x++
		}

        if (this.x > p5.width / this.xspacing) {
            this.y++
            this.initNewLine = true
            if (this.y > p5.height / this.yspacing + ySkip) { // finished pass
                this.pass++
                this.drawWhite = !this.drawWhite
                this.y = 1
                if (this.pass > 2) {
                    return true
                }
            }
        }

        return false
    }

    startAnimation() {
        this.running = true

        this.drawWhite = false
        this.pass = 1
        this.x = 1
        this.y = 1
        this.initNewLine = true

        this.chars.reset()
        this.fontSize.reset()
        this.span.reset()
        this.letterCount.reset()
        this.fontSize.reset()
    }
}

class BlackWhite extends React.Component {
    constructor(props) {
        super(props)

        this.parameterSet = null
        this.fontSize = 10

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    reset(p5) {
        p5.background(0)

        this.parameterSet = new ParameterSet(p5)
        this.parameterSet.startAnimation(p5)
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)

        this.fontSize = window.innerWidth / 60

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)

        this.reset(p5)
    }

    draw(p5) {
        if (this.parameterSet !== undefined) {
            for (var _ = 1; _ < 6; _++) {
                this.parameterSet.step(p5)
            }
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
BlackWhite.contextType = LanguageContext

export default BlackWhite
